<template>
  <UIDialogActions :is-open :z-index :actions :title @close="handleClose">
    {{ message }}
  </UIDialogActions>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'
import { DialogActionsButton } from './utils/types'

import UIDialogActions from './DialogActions.vue'

export type Props = {
  modal: ModalClass<any>

  title?: string
  message?: string
  label?: string
}

type Emits = {
  remove: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

defineOptions({
  name: 'UIDialogRemove',
})

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const actions = computed<DialogActionsButton[]>(() => [
  {
    label: props.label || '',
    onClick: handleRemove,
    buttonVariant: 'danger',
  },
])

const handleRemove = () => {
  handleClose()
  emit('remove')
}

const handleClose = () => {
  props.modal.close()
}
</script>
